window.$ = window.jQuery = require('jquery')
window.validator = require('validator/validator')
// require("@fancyapps/fancybox/dist/jquery.fancybox.min")
require("../elements/form")
// import Inputmask from 'inputmask'
import * as bootstrap from 'bootstrap'
window.bootstrap = bootstrap
import * as Popper from '@popperjs/core'
import IMask from 'imask'
import '../elements/calculator'

// import Sentry from your framework SDK (e.g. @sentry/react) instead of @sentry/browser
import * as Sentry from "@sentry/browser";
window.Sentry = Sentry

import {
    browserSupportsWebAuthn,
    startAuthentication,
    startRegistration,
} from '@simplewebauthn/browser'

window.browserSupportsWebAuthn = browserSupportsWebAuthn;
window.startAuthentication = startAuthentication;
window.startRegistration = startRegistration;

document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('#modal-data-lost')) {
        document.querySelectorAll('.js-data-lost').forEach(link => {
            link.onclick = event => {
                event.preventDefault()
                let modalDataLost = bootstrap.Modal.getOrCreateInstance(document.querySelector('#modal-data-lost'))
                modalDataLost._element.querySelector('.js-left').setAttribute('href', link.getAttribute('href'))
                modalDataLost.show()
            }
        })
    }

    const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]')
    const popoverList = [...popoverTriggerList].map(popoverTriggerEl => new bootstrap.Popover(popoverTriggerEl))
})

$(document).ready(function() {
    if ($("#modal-beforeunload").length) {
        $('a[href^="http"][id!="link-beforeunload"][target!="_blank"]').on("click", function(e) {
            e.preventDefault();
            var _href = $(this).attr('href');
            $('a#link-beforeunload').attr('href', _href);
            $('#modal-beforeunload').fancybox({
                touch: false
            }).trigger('click');
            return false;
        });
    }
    $("#link-beforeunload").on('click', function () {
       window.location.href = $(this).attr("href");
    });
    if ($('.js-change-lang').length) {
        $('.js-change-lang').click(function () {
            $(this).parents('.box-lang').toggleClass('active');
            $('.list-lang-wrap').slideToggle();
        });
    }
    if ($('.js-show-mob-menu').length) {
        $('.js-show-mob-menu').click(function () {
            $('.header').toggleClass('open-menu');
            $('.main-nav').slideToggle();
        });
    }
    if ($('.js-show-account-menu').length) {
        $('.js-show-account-menu').click(function () {
            $(this).next('.account-menu').slideToggle();
        });
    }
    // if ($('.fancybox').length) {
    //     $('.fancybox').fancybox({touch: false});
    // }

    /*menu btn*/
    function toggleMenu(elem) {
        $(elem).toggleClass('active');
        $(elem).next().toggleClass('opened');
        $('html').toggleClass('no-scroll');
        $('.overlay').toggle();
    }

    $('.js_menu-btn').on('click', function() {
        toggleMenu($(this))
    });

    $('.overlay').on('click', function() {
        toggleMenu('.js_menu-btn')
    });

    /* sticky-menu */
    var  menu = $(".js-fixed-header"),
        h_menu = $(".js-fixed-header").height();
    $(window).scroll(function() {
        if( $(this).scrollTop() > h_menu ) {
            menu.addClass('fixed');
        } else {
            menu.removeClass('fixed');
        }
    });
    if( $(this).scrollTop() > h_menu ) {
        menu.addClass('fixed');
    } else {
        menu.removeClass('fixed');
    }
    /* sticky-menu */
    if($('.js-scroll-top').length) {
        $(window).scroll(function () {
            if ($(this).scrollTop() > 0) {
                $('.js-scroll-top').addClass('visible');
            } else {
                $('.js-scroll-top').removeClass('visible');
            }
        });
        $('.js-scroll-top').click(function () {
            $('body,html').animate({
                scrollTop: 0
            }, 400);
            return false;
        });
    }
    if($('.js-scroll').length) {
        $('.js-scroll').click(function () {
            var target = $(this).attr('href');
            $('html, body').animate({
                scrollTop: $(target).offset().top
            }, 1000);
            return false;
        })
    }
    if ($(window).width() <= 767) {
        if($('.js-show-mob-nav').length) {
            $('.js-show-mob-nav').click(function () {
                $(this).toggleClass('active');
                $(this).parents('.footer__item').find('.footer-menu-list_hid-mob').slideToggle();
            });
        }
    }
    $(window).keydown(function(event){
        if(event.keyCode == 13) {
            event.preventDefault();
            return false;
        }
    });


    /*Function for same height*/

    window.addEventListener('load', function () {
        heightBlock();
    });

    window.addEventListener('orientationchange', function () {
        heightBlock();
    });

    $(window).on('resize', function () {
        heightBlock();
    });

    function heightBlock() {
        $('.js_height-block').each(function (i, e) {
                var elH = e.getElementsByClassName("height");
                var maxHeight = 0;
                for (var i = 0; i < elH.length; ++i) {
                    elH[i].style.height = "";
                    if (maxHeight < elH[i].clientHeight) {
                        maxHeight = elH[i].clientHeight;
                    }
                }
                for (var i = 0; i < elH.length; ++i) {
                    elH[i].style.height = maxHeight + "px";
                }
            }
        )
    }
});

document.addEventListener('DOMContentLoaded', () => {
    if (document.getElementById('modal-error')) new bootstrap.Modal(document.getElementById('modal-error')).show()
    if (document.getElementById('modal-errors')) new bootstrap.Modal(document.getElementById('modal-errors')).show()
    if (document.getElementById('modal-success')) new bootstrap.Modal(document.getElementById('modal-success')).show()

    if (statusUrl) {
        setInterval(async function () {
            await fetch(statusUrl, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                    'X-CSRFToken': document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
                },
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.changed === true || data.waiting_time_is_over) {
                        let modalSuccess = new bootstrap.Modal(document.getElementById('modal-information'))
                        modalSuccess._element.querySelector('.js-modal-body').innerHTML = `${data.text}<br>${data.status}`
                        modalSuccess.show()
                        if (profileUrl.replace(/\/+$/, '') === window.location.origin + window.location.pathname.replace(/\/+$/, '')) {
                            modalSuccess._element.addEventListener('hidden.bs.modal', () => {
                                window.location.href = profileUrl.replace(/\/+$/, '')
                            })
                        }
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }, 1000 * 15);
    }
})